import React from 'react';

export const dutch = (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0885 32.0012C7.25194 32.0012 0.088501 24.8375 0.088501 16.0006C0.088501 7.16371 7.25194 0 16.0885 0C24.9251 0 32.0885 7.16371 32.0885 16.0006C32.0885 24.8375 24.9251 32.0012 16.0885 32.0012Z"
      fill="white"
    />
    <path
      d="M11.052 10.6683H1.42192C1.42363 10.6632 1.42515 10.659 1.42687 10.6543C3.42737 4.84378 8.57279 1.23545 14.7552 0.667969C12.3627 2.01898 11.6641 5.63269 11.052 10.6683Z"
      fill="#E63026"
    />
    <path
      d="M14.7552 30.6696C8.57131 30.1751 3.42645 26.4436 1.43694 21.3757C1.43173 21.3623 1.42732 21.349 1.42192 21.3359H11.0502C11.656 25.7399 12.3567 29.4895 14.7552 30.6696Z"
      fill="#2B479D"
    />
    <path
      d="M30.7501 10.6531C30.7519 10.6577 30.7535 10.662 30.7552 10.6671H9.42192C10.0542 5.6625 11.6171 2.00935 14.0886 0.666691C14.5666 0.624666 15.0405 0 15.5296 0C22.5543 0 28.5287 4.44613 30.7501 10.6531Z"
      fill="#E63026"
    />
    <path
      d="M9.42192 21.3359H30.7552C30.7499 21.3489 30.745 21.3621 30.7397 21.3755C28.5301 26.7886 22.5561 30.6696 15.5294 30.6696C15.041 30.6696 14.5582 30.6489 14.0809 30.612C11.6023 29.4393 10.0481 25.7128 9.42192 21.3359Z"
      fill="#2B479D"
    />
    <path
      d="M31.0885 16.0006C31.0885 24.2852 24.3727 31.0012 16.0885 31.0012C7.80426 31.0012 1.0885 24.2852 1.0885 16.0006C1.0885 7.71596 7.80426 1 16.0885 1C24.3727 1 31.0885 7.71596 31.0885 16.0006Z"
      stroke="#EEEEEE"
      strokeWidth="2"
    />
  </svg>
);

export const english = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_11264_279299)">
      <mask id="mask0_11264_279299" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="27" height="27">
        <path
          d="M5.07247 26.1274C-0.734078 20.3209 -0.734079 10.9066 5.07247 5.10004C10.879 -0.706515 20.2933 -0.706514 26.0999 5.10004C13.6149 17.5851 11.9721 19.2278 5.07247 26.1274Z"
          fill="#CB0000"
        />
      </mask>
      <g mask="url(#mask0_11264_279299)">
        <path
          d="M16.6667 30.667C8.93476 30.667 2.66675 24.1004 2.66675 16.0002C2.66675 7.89992 8.93476 1.33337 16.6667 1.33337C24.3987 1.33337 30.6667 7.89992 30.6667 16.0002C30.6667 24.1004 24.3987 30.667 16.6667 30.667Z"
          fill="white"
        />
        <path
          d="M11.3338 10.6668H2.66675C2.66829 10.6623 2.66966 10.6586 2.6712 10.6545C4.47165 5.57045 9.10253 1.8299 14.6667 1.33337C12.5135 2.51548 11.8847 6.26072 11.3338 10.6668Z"
          fill="#E63026"
        />
        <path
          d="M14.6667 30.667C9.10121 30.1725 4.47083 26.4411 2.68027 21.3734C2.67558 21.3599 2.67161 21.3466 2.66675 21.3336H11.3322C11.8775 25.7374 12.508 29.4869 14.6667 30.667Z"
          fill="#2B479D"
        />
        <path
          d="M30.662 10.6546C30.6636 10.6586 30.6651 10.6624 30.6667 10.6668H10.6667C11.2596 6.28793 12.7158 2.56592 15.0328 1.39113C15.4809 1.35436 15.9342 1.33337 16.3927 1.33337C22.9784 1.33337 28.5793 5.22363 30.662 10.6546Z"
          fill="#E63026"
        />
        <path
          d="M10.6667 21.3336H30.6667C30.6617 21.3465 30.6572 21.3597 30.6522 21.3731C28.5807 26.7861 22.9801 30.667 16.3925 30.667C15.9346 30.667 15.4821 30.6463 15.0345 30.6094C12.7109 29.4366 11.2538 25.7103 10.6667 21.3336Z"
          fill="#2B479D"
        />
        <path
          d="M16.6667 30.667C24.3987 30.667 30.6667 24.1004 30.6667 16.0002C30.6667 7.89992 24.3987 1.33337 16.6667 1.33337C8.93476 1.33337 2.66675 7.89992 2.66675 16.0002C2.66675 24.1004 8.93476 30.667 16.6667 30.667Z"
          fill="#DC3027"
        />
        <path
          d="M2.66675 16.0003C2.66675 7.89936 8.99838 1.33337 16.8087 1.33337C24.6194 1.33337 24.6194 30.667 16.8087 30.667C8.99856 30.6667 2.66675 24.1002 2.66675 16.0003Z"
          fill="#DC3027"
        />
        <path
          d="M16 32C24.8366 32 32 25.0604 32 16.5C32 7.93959 24.8366 1 16 1C7.16344 1 0 7.93959 0 16.5C0 25.0604 7.16344 32 16 32Z"
          fill="#F0F0F0"
        />
        <path d="M16 16.0002H30.6667C30.6667 14.6162 30.4976 13.2755 30.1825 12.0001H16V16.0002Z" fill="#D80027" />
        <path d="M16 8.0001H29.3333C28.4231 6.46844 27.2593 5.11461 25.9024 4.00006H16V8.0001Z" fill="#D80027" />
        <path
          d="M3.03945 24.0002H28.9604C29.7069 22.7706 30.2858 21.4265 30.6666 20.0002H1.33325C1.71401 21.4265 2.29295 22.7706 3.03945 24.0002Z"
          fill="#D80027"
        />
        <path
          d="M8.12713 3.6238H9.46368L8.22046 4.52701L8.69535 5.98848L7.45217 5.08527L6.209 5.98848L6.61921 4.72593C5.5246 5.63774 4.56519 6.70601 3.77456 7.89631H4.20282L3.41145 8.47124C3.28816 8.67692 3.16991 8.88586 3.05659 9.0979L3.43448 10.261L2.72945 9.74874C2.55419 10.12 2.39389 10.4997 2.2498 10.8873L2.66614 12.1688H4.20282L2.95959 13.072L3.43448 14.5335L2.19131 13.6303L1.44663 14.1714C1.3721 14.7705 1.33325 15.3808 1.33325 16.0002H15.9999C15.9999 7.89998 15.9999 6.94503 15.9999 1.33337C13.1026 1.33337 10.4017 2.17385 8.12713 3.6238ZM8.69535 14.5335L7.45217 13.6303L6.209 14.5335L6.68389 13.072L5.44066 12.1688H6.97734L7.45217 10.7074L7.92701 12.1688H9.46368L8.22046 13.072L8.69535 14.5335ZM8.22046 8.79952L8.69535 10.261L7.45217 9.35778L6.209 10.261L6.68389 8.79952L5.44066 7.89631H6.97734L7.45217 6.43484L7.92701 7.89631H9.46368L8.22046 8.79952ZM13.9562 14.5335L12.713 13.6303L11.4699 14.5335L11.9448 13.072L10.7015 12.1688H12.2382L12.713 10.7074L13.1879 12.1688H14.7245L13.4813 13.072L13.9562 14.5335ZM13.4813 8.79952L13.9562 10.261L12.713 9.35778L11.4699 10.261L11.9448 8.79952L10.7015 7.89631H12.2382L12.713 6.43484L13.1879 7.89631H14.7245L13.4813 8.79952ZM13.4813 4.52701L13.9562 5.98848L12.713 5.08527L11.4699 5.98848L11.9448 4.52701L10.7015 3.6238H12.2382L12.713 2.16233L13.1879 3.6238H14.7245L13.4813 4.52701Z"
          fill="#0052B4"
        />
      </g>
      <mask id="mask1_11264_279299" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="5" y="5" width="27" height="27">
        <path
          d="M27.1624 5.16261C33.2437 11.2439 33.2436 21.1036 27.1623 27.1849C21.081 33.2662 11.2213 33.2663 5.14002 27.185C13.718 18.6071 17.611 14.714 27.1624 5.16261Z"
          fill="#CB0000"
        />
      </mask>
      <g mask="url(#mask1_11264_279299)">
        <path
          d="M30.0318 -1.33337H1.96834C0.144919 -1.33337 -1.33325 0.736084 -1.33325 3.28889V28.7113C-1.33325 31.2642 0.144919 33.3336 1.96834 33.3336H30.0318C31.8552 33.3336 33.3334 31.2642 33.3334 28.7113V3.28889C33.3334 0.736084 31.8552 -1.33337 30.0318 -1.33337Z"
          fill="#22438B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.45372 5.33337L1.33325 5.37595L1.3733 8.6084L27.5292 26.6669L30.6666 26.6063L30.6081 23.3935L4.45372 5.33337Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.87711 5.33337L1.33325 6.97441L29.1227 26.6669L30.6666 25.0259L2.87711 5.33337Z"
          fill="#C7152A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.4614 5.33337H30.6667V8.60329C30.6667 8.60329 11.8356 20.6954 3.4505 26.6336C3.34953 26.7055 0.24841 26.6385 0.24841 26.6385L0 23.5305L27.4614 5.33337Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.3882 5.33337L32 7.01674L1.68421 26.6669L0 25.0294L30.3882 5.33337Z"
          fill="#C7152A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1403 -5.33337H19.8596V11.8976H31.6666V20.1028H19.8596V37.3337H12.1403V20.1028H0.333252V11.8976H12.1403V-5.33337Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6841 0.333374H18.3157V13.6412H31.6666V18.3592H18.3157V32.0003H13.6841V18.3592H0.333252V13.6412H13.6841V0.333374Z"
          fill="#C7152A"
        />
      </g>
      <path
        d="M31 16.0001C31 24.2845 24.2843 31.0003 16 31.0003C7.71574 31.0003 1 24.2845 1 16.0001C1 7.71579 7.71574 1 16 1C24.2843 1 31 7.71579 31 16.0001Z"
        stroke="#EEEEEE"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_11264_279299">
        <rect width="32" height="31.9991" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const french = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6003_84021)">
      <g clipPath="url(#clip1_6003_84021)">
        <ellipse cx="16" cy="16.0006" rx="16" ry="16.0006" fill="white" />
        <path
          d="M30.6667 15.9992C30.6667 9.27457 26.783 3.54185 21.3334 1.33203V30.6664C26.783 28.4566 30.6667 22.7238 30.6667 15.9992Z"
          fill="#D80027"
        />
        <path d="M0 15.9992C0 22.7239 4.43854 28.4566 10.6667 30.6664V1.33203C4.43854 3.54185 0 9.27459 0 15.9992Z" fill="#0052B4" />
      </g>
      <path
        d="M31 16.0006C31 24.2852 24.2842 31.0012 16 31.0012C7.71576 31.0012 1 24.2852 1 16.0006C1 7.71596 7.71576 1 16 1C24.2842 1 31 7.71596 31 16.0006Z"
        stroke="#EEEEEE"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_6003_84021">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_6003_84021">
        <rect width="32" height="32.0012" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const spanish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6003_84029)">
      <g clipPath="url(#clip1_6003_84029)">
        <path
          d="M1.33337 15.9989C1.33337 17.8746 1.6561 19.6713 2.24563 21.3325L16 22.6659L29.7544 21.3325C30.344 19.6713 30.6667 17.8746 30.6667 15.9989C30.6667 14.1233 30.344 12.3266 29.7544 10.6654L16 9.33203L2.24563 10.6654C1.6561 12.3266 1.33337 14.1233 1.33337 15.9989Z"
          fill="#FFDA44"
        />
        <path d="M30.6667 10.6671C28.457 4.4387 22.7244 0 16 0C9.27564 0 3.54312 4.4387 1.33337 10.6671H30.6667Z" fill="#D80027" />
        <path
          d="M1.33337 21.3359C3.54312 27.5643 9.27564 32.003 16 32.003C22.7244 32.003 28.457 27.5643 30.6667 21.3359H1.33337Z"
          fill="#D80027"
        />
      </g>
      <path
        d="M31 16.0006C31 24.2852 24.2842 31.0012 16 31.0012C7.71576 31.0012 1 24.2852 1 16.0006C1 7.71596 7.71576 1 16 1C24.2842 1 31 7.71596 31 16.0006Z"
        stroke="#EEEEEE"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_6003_84029">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_6003_84029">
        <rect width="32" height="32.0012" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const german = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6003_84037)">
      <g clipPath="url(#clip1_6003_84037)">
        <path
          d="M1.33337 21.4118C3.54312 27.5944 9.27564 32.0004 16 32.0004C22.7244 32.0004 28.457 27.5944 30.6667 21.4118L16 20L1.33337 21.4118Z"
          fill="#FFDA44"
        />
        <path
          d="M16 0C9.27564 0 3.54312 4.40602 1.33337 10.5887L16 12.0004L30.6667 10.5886C28.457 4.40602 22.7244 0 16 0Z"
          fill="black"
        />
        <path
          d="M0.953721 10.668C0.337393 12.3291 0 14.1258 0 16.0015C0 17.8772 0.337393 19.6739 0.953721 21.335H29.713C30.3293 19.6739 30.6667 17.8772 30.6667 16.0015C30.6667 14.1258 30.3293 12.3291 29.7129 10.668H0.953721Z"
          fill="#D80027"
        />
      </g>
      <path
        d="M31 16.0006C31 24.2852 24.2842 31.0012 16 31.0012C7.71576 31.0012 1 24.2852 1 16.0006C1 7.71596 7.71576 1 16 1C24.2842 1 31 7.71596 31 16.0006Z"
        stroke="#EEEEEE"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_6003_84037">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_6003_84037">
        <rect width="32" height="32.0012" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const arabic = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8877_213870)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M0.995117 21.5652C3.2558 27.658 9.12049 32 15.9999 32C22.8794 32 28.7441 27.658 31.0047 21.5652L15.9999 20.174L0.995117 21.5652Z"
        fill="white"
      />
      <path
        d="M15.9999 0C9.12049 0 3.2558 4.342 0.995117 10.4348L15.9999 11.8261L31.0047 10.4347C28.7441 4.342 22.8794 0 15.9999 0Z"
        fill="black"
      />
      <path
        d="M0.995188 10.4348C0.352063 12.1681 0 14.0429 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652H31.0049C31.648 19.8319 32 17.9571 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348H0.995188Z"
        fill="#007A3D"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <path
      d="M5.68628 5C-0.562094 11.2484 -0.562094 21.3791 5.68628 27.6275C8.26834 25.0454 10.7517 22.5621 17 16.3137L5.68628 5Z"
      fill="#CE1126"
    />
    <circle cx="16" cy="16" r="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_8877_213870">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bulgarian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164472)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M32 16C32 14.0429 31.648 12.1681 31.0048 10.4348L16 9.73914L0.995188 10.4348C0.352063 12.1681 0 14.0429 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.2609L31.0048 21.5653C31.648 19.8319 32 17.9571 32 16Z"
        fill="#496E2D"
      />
      <path d="M15.9999 32C22.8794 32 28.7441 27.658 31.0047 21.5652H0.995117C3.2558 27.658 9.12049 32 15.9999 32Z" fill="#D80027" />
      <path d="M0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 15.9999 0C9.12049 0 3.2558 4.342 0.995117 10.4348Z" fill="#F0F0F0" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164472">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const catalan_sp = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="30" height="30" rx="15" fill="white" />
    <path
      d="M0 28C0 28.7033 0.352063 29.3771 0.995188 30H16H31.0048C31.6479 29.3771 32 28.7033 32 28C32 27.2967 31.6479 26.6229 31.0048 26L16 26L0.995188 26C0.352063 26.6229 0 27.2967 0 28Z"
      fill="#FFDA44"
    />
    <path
      d="M0 24.5C0 25.0275 0.352063 25.5328 0.995188 26H16H31.0048C31.6479 25.5328 32 25.0275 32 24.5C32 23.9725 31.6479 23.4672 31.0048 23L16 23L0.995188 23C0.352063 23.4672 0 23.9725 0 24.5Z"
      fill="#D80027"
    />
    <path
      d="M0 21.5C0 22.0275 0.352063 22.5328 0.995188 23H16H31.0048C31.6479 22.5328 32 22.0275 32 21.5C32 20.9725 31.6479 20.4672 31.0048 20L16 20L0.995188 20C0.352063 20.4672 0 20.9725 0 21.5Z"
      fill="#FFDA44"
    />
    <path
      d="M0 18.5C0 19.0275 0.352063 19.5328 0.995188 20H16H31.0048C31.6479 19.5328 32 19.0275 32 18.5C32 17.9725 31.6479 17.4672 31.0048 17L16 17L0.995188 17C0.352063 17.4672 0 17.9725 0 18.5Z"
      fill="#D80027"
    />
    <path
      d="M0 15.5C0 16.0275 0.352063 16.5328 0.995188 17H16H31.0048C31.6479 16.5328 32 16.0275 32 15.5C32 14.9725 31.6479 14.4672 31.0048 14L16 14L0.995188 14C0.352063 14.4672 0 14.9725 0 15.5Z"
      fill="#FFDA44"
    />
    <path
      d="M0 9.5C0 10.0275 0.352063 10.5328 0.995188 11H16H31.0048C31.6479 10.5328 32 10.0275 32 9.5C32 8.97249 31.6479 8.46718 31.0048 8L16 8L0.995188 8C0.352063 8.46718 0 8.97249 0 9.5Z"
      fill="#FFDA44"
    />
    <path
      d="M0 3.5C0 4.02751 0.352063 4.53282 0.995188 5H16H31.0048C31.6479 4.53282 32 4.02751 32 3.5C32 2.97249 31.6479 2.46718 31.0048 2L16 2L0.995188 2C0.352063 2.46718 0 2.97249 0 3.5Z"
      fill="#FFDA44"
    />
    <path
      d="M0 12.5C0 13.0275 0.352063 13.5328 0.995188 14H16H31.0048C31.6479 13.5328 32 13.0275 32 12.5C32 11.9725 31.6479 11.4672 31.0048 11L16 11L0.995188 11C0.352063 11.4672 0 11.9725 0 12.5Z"
      fill="#D80027"
    />
    <path
      d="M0 6.5C0 7.02751 0.352063 7.53282 0.995188 8H16H31.0048C31.6479 7.53282 32 7.02751 32 6.5C32 5.97249 31.6479 5.46718 31.0048 5L16 5L0.995188 5C0.352063 5.46718 0 5.97249 0 6.5Z"
      fill="#D80027"
    />
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
  </svg>
);

export const czech = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164473)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.6085 16C14.6085 16 4.69541 27.3159 4.68604 27.3137C7.58141 30.2091 11.5815 32 15.9998 32C24.8363 32 31.9998 24.8365 31.9998 16H14.6085Z"
        fill="#D80027"
      />
      <path
        d="M4.68628 4.68628C-1.56209 10.9347 -1.56209 21.0653 4.68628 27.3138C7.26834 24.7317 9.75166 22.2484 16 16L4.68628 4.68628Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164473">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const danish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164474)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.5215 13.9131H31.8643C30.8416 6.06262 24.1289 0 15.9997 0C14.805 0 13.6415 0.132063 12.5215 0.380313V13.9131H12.5215Z"
        fill="#D80027"
      />
      <path d="M8.34763 13.913V1.94543C3.95432 4.34256 0.809191 8.7395 0.135254 13.9131H8.34763V13.913Z" fill="#D80027" />
      <path d="M8.34757 18.0869H0.135254C0.809191 23.2605 3.95432 27.6574 8.34763 30.0545L8.34757 18.0869Z" fill="#D80027" />
      <path
        d="M12.5215 18.087V31.6197C13.6415 31.8679 14.805 32 15.9997 32C24.1289 32 30.8416 25.9374 31.8643 18.0869H12.5215V18.087Z"
        fill="#D80027"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164474">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const greek = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164479)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path d="M16 11.826H31.4488C31.0476 10.3377 30.4379 8.9351 29.6516 7.6521H16V11.826Z" fill="#338AF3" />
      <path
        d="M6.03996 28.5217H25.9595C27.4197 27.3587 28.672 25.9461 29.6513 24.3478H2.34814C3.32758 25.946 4.57983 27.3587 6.03996 28.5217Z"
        fill="#338AF3"
      />
      <path d="M5.56496 3.87122C4.30708 4.9544 3.21964 6.22997 2.34814 7.65222H5.56496V3.87122Z" fill="#338AF3" />
      <path
        d="M16 16C16 14.3702 16 13.0063 16 11.826H9.73913V16H5.56519V11.826H0.551188C0.1925 13.1569 0 14.5558 0 16C0 17.4442 0.1925 18.843 0.551188 20.1739H31.4489C31.8075 18.843 32 17.4442 32 16H16Z"
        fill="#338AF3"
      />
      <path
        d="M16.0001 0C13.7783 0 11.6624 0.453312 9.73926 1.27175V7.65219H16.0001C16.0001 6.19519 16.0001 4.956 16.0001 3.47825H25.9599C23.2268 1.3015 19.7657 0 16.0001 0Z"
        fill="#338AF3"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164479">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const estonian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164480)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.2609L31.0048 21.5653C31.648 19.8319 32 17.9571 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348L16 9.73914L0.995188 10.4348C0.352063 12.1681 0 14.0429 0 16H0Z"
        fill="black"
      />
      <path d="M15.9999 0C9.12049 0 3.2558 4.342 0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 15.9999 0Z" fill="#0052B4" />
      <path
        d="M31.0047 21.5652H0.995117C3.2558 27.6579 9.12049 32 15.9999 32C22.8794 32 28.7441 27.6579 31.0047 21.5652Z"
        fill="#F0F0F0"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164480">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const finnish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164481)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.8646 13.9131H12.5218H12.5218V0.380371C11.0431 0.708246 9.64131 1.23968 8.34781 1.9455V13.913V13.9131H0.135438C0.046375 14.5962 0 15.2927 0 16.0001C0 16.7074 0.046375 17.4039 0.135438 18.087H8.34775H8.34781V30.0546C9.64131 30.7603 11.0431 31.2919 12.5218 31.6197V18.0872V18.0871H31.8646C31.9535 17.4039 32 16.7074 32 16.0001C32 15.2927 31.9535 14.5962 31.8646 13.9131Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164481">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const filipino = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164482)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.9998 0V16L4.68604 27.3137C7.58147 30.2091 11.5815 32 15.9998 32C24.8363 32 31.9998 24.8365 31.9998 16C31.9998 7.1635 15.9998 0 15.9998 0Z"
        fill="#D80027"
      />
      <path
        d="M15.9998 0C11.5815 0 7.58147 1.79088 4.68604 4.68625C8.61166 8.61188 10.0052 10.0055 15.9998 16H31.9998C31.9998 7.1635 24.8363 0 15.9998 0Z"
        fill="#0052B4"
      />
      <path
        d="M10.9555 16L9.00149 15.0809L10.0421 13.1884L7.92018 13.5944L7.6513 11.4508L6.1733 13.0273L4.69536 11.4508L4.42643 13.5944L2.30461 13.1884L3.34518 15.0809L1.39111 16L3.34518 16.9191L2.30461 18.8116L4.42661 18.4057L4.6953 20.5492L6.1733 18.9727L7.6513 20.5492L7.92018 18.4057L10.0419 18.8116L9.00143 16.9192L10.9555 16Z"
        fill="#FFDA44"
      />
      <path
        d="M4.26662 6.26086L4.91687 7.1698L5.98218 6.83236L5.31856 7.73161L5.96881 8.64055L4.90843 8.28736L4.24487 9.18655L4.25318 8.06905L3.19287 7.7158L4.25837 7.37836L4.26662 6.26086Z"
        fill="#FFDA44"
      />
      <path
        d="M4.26662 22.8135L4.91687 23.7224L5.98218 23.3849L5.31856 24.2842L5.96881 25.1932L4.90843 24.84L4.24487 25.7392L4.25318 24.6217L3.19287 24.2684L4.25837 23.931L4.26662 22.8135Z"
        fill="#FFDA44"
      />
      <path
        d="M13.5412 14.5372L12.8911 15.4462L11.8257 15.1086L12.4893 16.0079L11.8391 16.9169L12.8994 16.5637L13.5631 17.4629L13.5547 16.3454L14.615 15.9922L13.5496 15.6547L13.5412 14.5372Z"
        fill="#FFDA44"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164482">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const canadian_fr = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="30" height="30" rx="15" fill="white" />
    <path
      d="M18.3808 11.4021C18.4135 11.5201 18.4412 11.6191 18.4684 11.7182C18.488 11.79 18.5015 11.8644 18.5281 11.9335C18.553 11.9986 18.6012 12.0491 18.6751 12.0439C18.7597 12.0377 18.8445 12.0265 18.9278 12.0091C19.0647 11.9807 19.2003 11.9452 19.3366 11.9137C19.493 11.8775 19.6497 11.8424 19.8063 11.8074C19.8145 11.8055 19.8235 11.8072 19.8388 11.8072C19.7834 12.0184 19.7288 12.2246 19.6757 12.4313C19.6161 12.6637 19.555 12.8957 19.5001 13.1293C19.4743 13.2395 19.5036 13.2859 19.603 13.3339C19.7169 13.3887 19.8306 13.4445 19.944 13.5005C19.96 13.5084 19.9748 13.5191 20 13.5344C19.9424 13.5854 19.8902 13.6335 19.8363 13.6791C19.5408 13.9289 19.2447 14.1783 18.9493 14.4281C18.6618 14.671 18.373 14.9121 18.0886 15.1586C17.9612 15.2689 17.971 15.3643 18.0163 15.5097C18.0659 15.669 18.1119 15.8297 18.1615 15.9963C18.1185 15.9963 18.0828 16.0001 18.0481 15.9956C17.9319 15.9803 17.816 15.9627 17.7003 15.9446C17.5619 15.9229 17.4234 15.9007 17.2855 15.8762C17.199 15.8607 17.1997 15.8633 17.1734 15.9455C17.1034 16.1651 17.0294 16.383 16.9557 16.6011C16.8931 16.7866 16.8286 16.9714 16.7657 17.1566C16.7028 17.3418 16.6399 17.5273 16.5786 17.7133C16.4762 18.0241 16.3998 18.3412 16.3514 18.6666C16.3081 18.9575 16.302 19.2495 16.2953 19.5423C16.2944 19.5797 16.2983 19.6174 16.3001 19.6598C16.4382 19.6598 16.5727 19.6598 16.7124 19.6598C16.714 19.6357 16.7156 19.6131 16.717 19.5902C16.7264 19.43 16.7259 19.2686 16.7465 19.11C16.803 18.6747 16.8995 18.2504 17.0916 17.8549C17.3076 17.4103 17.615 17.0639 18.0687 16.8801C18.2498 16.8069 18.4366 16.7895 18.6316 16.8338C18.9557 16.9075 19.2086 17.0951 19.4023 17.3621C19.6177 17.6591 19.694 18.007 19.6693 18.3779C19.6355 18.8852 19.3847 19.244 18.9582 19.4688C18.8171 19.5432 18.6566 19.578 18.5047 19.6302C18.4972 19.6328 18.4878 19.6293 18.4697 19.6276C18.5676 19.4631 18.5676 19.2855 18.5502 19.1103C18.5285 18.8914 18.4393 18.6986 18.2303 18.6237C17.9401 18.5198 17.6518 18.5543 17.4419 18.8766C17.3234 19.0585 17.2477 19.26 17.2272 19.4815C17.2235 19.5213 17.2139 19.5604 17.2084 19.5999C17.2018 19.6483 17.2217 19.6665 17.2697 19.666C17.4716 19.6638 17.6735 19.665 17.8752 19.6653C17.891 19.6653 17.9068 19.6669 17.9296 19.6681C17.9296 19.944 17.9296 20.2186 17.9296 20.5009C17.8304 20.5009 17.7355 20.5009 17.6408 20.5009C17.2665 20.5009 16.8924 20.5006 16.5181 20.5006C16.4323 20.5006 16.433 20.5049 16.443 20.5946C16.4675 20.8096 16.5421 21.0003 16.6793 21.1641C16.778 21.2821 16.8967 21.3729 17.0289 21.4456C17.0506 21.4576 17.0717 21.4702 17.106 21.49C17.0689 21.5586 17.0392 21.6285 16.9971 21.6893C16.8965 21.8352 16.7673 21.9456 16.5997 21.9992C16.5743 22.0073 16.5457 22.0064 16.5187 22.0052C16.4632 22.0025 16.4392 22.0278 16.4293 22.0857C16.3969 22.2784 16.3514 22.4679 16.2489 22.635C16.1757 22.7542 16.0934 22.8675 16.0038 23C15.9416 22.9213 15.8878 22.8577 15.8384 22.7904C15.7022 22.605 15.6187 22.3952 15.5787 22.1661C15.5718 22.1267 15.5682 22.0853 15.5526 22.0497C15.5441 22.0302 15.5146 22.0104 15.4936 22.0087C15.1966 21.9866 15.0333 21.7863 14.9082 21.5348C14.8865 21.4912 14.9142 21.4714 14.9471 21.4537C15.1106 21.3662 15.2535 21.2528 15.364 21.0976C15.4737 20.9436 15.5281 20.7676 15.5544 20.5802C15.5631 20.519 15.5439 20.4992 15.4819 20.4997C15.0374 20.5025 14.5929 20.5011 14.1483 20.5011C14.1214 20.5011 14.0946 20.5011 14.0615 20.5011C14.0615 20.2231 14.0615 19.9502 14.0615 19.6684C14.2974 19.6684 14.5339 19.6684 14.7841 19.6684C14.7726 19.5637 14.7765 19.4645 14.7488 19.3761C14.6992 19.2171 14.6388 19.0605 14.5682 18.9103C14.4978 18.7605 14.3738 18.6628 14.2229 18.6068C14.0974 18.5603 13.9686 18.5722 13.8417 18.5982C13.6524 18.6368 13.5373 18.7694 13.4747 18.9491C13.4184 19.1105 13.4102 19.2793 13.4527 19.4474C13.4678 19.5072 13.4884 19.5656 13.511 19.6398C13.4152 19.6121 13.3238 19.5907 13.2355 19.5597C13.0032 19.4781 12.7944 19.3539 12.6277 19.1634C12.4093 18.9141 12.313 18.6142 12.314 18.2804C12.3151 17.9078 12.4107 17.5657 12.6519 17.2822C12.8294 17.0736 13.0434 16.9165 13.3059 16.8436C13.579 16.7678 13.8358 16.8214 14.0832 16.9542C14.5035 17.1797 14.768 17.5473 14.9562 17.985C15.0706 18.2511 15.1492 18.5291 15.192 18.8173C15.2133 18.9608 15.23 19.105 15.2453 19.2495C15.2595 19.3828 15.2688 19.5165 15.2809 19.6574C15.2922 19.6593 15.3091 19.6646 15.3262 19.6648C15.4328 19.6655 15.5393 19.6643 15.6461 19.6657C15.6834 19.6662 15.7063 19.6591 15.7038 19.6116C15.6928 19.3968 15.6889 19.1816 15.6722 18.9672C15.6601 18.8123 15.637 18.6576 15.6093 18.5047C15.5819 18.3531 15.548 18.2022 15.5076 18.0537C15.4525 17.8513 15.3921 17.6498 15.3271 17.4505C15.2485 17.2093 15.1616 16.9709 15.0804 16.7306C14.988 16.4574 14.8988 16.1832 14.8053 15.9107C14.7991 15.8928 14.7655 15.8716 14.7475 15.8742C14.6132 15.8931 14.4799 15.9183 14.3461 15.94C14.286 15.9498 14.2252 15.9563 14.1648 15.9641C14.0626 15.9772 13.9604 15.9903 13.8417 16.0056C13.8682 15.9133 13.8922 15.8342 13.9137 15.7543C13.9464 15.6335 13.983 15.5131 14.0073 15.3903C14.0267 15.2923 13.9828 15.2139 13.9087 15.1514C13.5122 14.816 13.1164 14.4794 12.7201 14.1435C12.4962 13.9537 12.2721 13.7642 12.048 13.5746C12.0359 13.5644 12.024 13.5534 12 13.5324C12.0798 13.4922 12.1491 13.4562 12.2191 13.4216C12.2854 13.3889 12.3538 13.3601 12.4187 13.3248C12.5033 13.2788 12.5294 13.2161 12.504 13.105C12.4708 12.9598 12.4313 12.8158 12.3933 12.6718C12.3556 12.529 12.316 12.3867 12.2776 12.2441C12.2431 12.1164 12.2083 11.9886 12.1747 11.8606C12.1708 11.8455 12.1724 11.8288 12.1713 11.806C12.3078 11.8355 12.4388 11.8641 12.5701 11.8927C12.7183 11.9249 12.8662 11.9576 13.0144 11.9891C13.1084 12.0091 13.2021 12.036 13.2972 12.0444C13.4065 12.0541 13.4626 11.9952 13.49 11.8856C13.5296 11.7278 13.5767 11.5719 13.6242 11.4021C13.7313 11.5285 13.8284 11.6441 13.9265 11.7585C14.1211 11.986 14.3166 12.2124 14.5106 12.4408C14.5634 12.503 14.6238 12.5376 14.7054 12.5314C14.7639 12.5269 14.8049 12.4956 14.8074 12.4391C14.8119 12.3416 14.8113 12.2422 14.7989 12.1457C14.7815 12.0096 14.7514 11.8749 14.7267 11.7397C14.6889 11.5342 14.6505 11.3287 14.6132 11.1232C14.5908 11.0004 14.5712 10.8772 14.5481 10.7546C14.5247 10.6309 14.4975 10.5081 14.4749 10.3844C14.4605 10.3055 14.4516 10.2254 14.4381 10.1324C14.6201 10.2299 14.7889 10.3162 14.9535 10.4099C15.1179 10.5033 15.2498 10.4611 15.3331 10.2919C15.5384 9.87469 15.7557 9.46369 15.9686 9.05054C15.9768 9.03457 15.9901 9.02122 16.0061 9C16.0891 9.1602 16.1693 9.3154 16.2496 9.47084C16.3948 9.75215 16.5423 10.0323 16.6834 10.3157C16.755 10.4595 16.8668 10.5017 17.0271 10.423C17.2063 10.3348 17.3792 10.2325 17.567 10.1295C17.5567 10.2046 17.5498 10.2721 17.5377 10.3384C17.5247 10.4092 17.5041 10.4786 17.4913 10.5494C17.4419 10.8199 17.3939 11.0908 17.3465 11.3618C17.3243 11.4887 17.3056 11.6164 17.2829 11.7433C17.2537 11.9066 17.2203 12.0692 17.1919 12.2327C17.1828 12.2856 17.1775 12.3409 17.1816 12.3943C17.191 12.5169 17.3022 12.5808 17.4012 12.5126C17.4741 12.4623 17.5359 12.3915 17.5953 12.3228C17.8137 12.0701 18.0291 11.8145 18.2459 11.5602C18.287 11.5099 18.3293 11.4615 18.3808 11.4021Z"
      fill="#FF0000"
    />
    <rect x="6" y="2" width="5" height="28" fill="#0065BD" />
    <rect x="1" y="2" width="5" height="28" fill="#FF0000" />
    <rect x="26" y="2" width="5" height="28" fill="#FF0000" />
    <rect x="21" y="2" width="5" height="28" fill="#0065BD" />
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
  </svg>
);

export const irish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164484)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path
        d="M32.0002 16C32.0002 9.12061 27.6582 3.25586 21.5654 0.995239V31.0049C27.6582 28.7441 32.0002 22.8795 32.0002 16V16Z"
        fill="#FF9811"
      />
      <path d="M0 16C0 22.8795 4.342 28.7441 10.4348 31.0049V0.995239C4.342 3.25586 0 9.12061 0 16V16Z" fill="#6DA544" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164484">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const hindi = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164485)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#F0F0F0"
      />
      <path d="M15.9998 0C9.6564 0 4.1754 3.69156 1.5874 9.0435H30.4121C27.8242 3.69156 22.3431 0 15.9998 0Z" fill="#FF9811" />
      <path d="M15.9998 32C22.3431 32 27.8242 28.3085 30.4122 22.9565H1.5874C4.1754 28.3085 9.6564 32 15.9998 32Z" fill="#6DA544" />
      <path
        d="M15.9998 21.5652C19.0733 21.5652 21.5649 19.0736 21.5649 16C21.5649 12.9264 19.0733 10.4348 15.9998 10.4348C12.9262 10.4348 10.4346 12.9264 10.4346 16C10.4346 19.0736 12.9262 21.5652 15.9998 21.5652Z"
        fill="#0052B4"
      />
      <path
        d="M16.0002 19.4782C17.9212 19.4782 19.4785 17.921 19.4785 16C19.4785 14.079 17.9212 12.5217 16.0002 12.5217C14.0792 12.5217 12.522 14.079 12.522 16C12.522 17.921 14.0792 19.4782 16.0002 19.4782Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.9998 11.7079L17.0728 14.1415L19.7168 13.8539L18.1458 16L19.7168 18.1461L17.0728 17.8585L15.9998 20.2921L14.9267 17.8585L12.2827 18.146L13.8537 16L12.2827 13.8539L14.9267 14.1415L15.9998 11.7079Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164485">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const croatian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164486)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M32 16C32 14.0429 31.6479 12.1681 31.0048 10.4348L16 9.73914L0.995188 10.4348C0.352063 12.1681 0 14.0429 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.2609L31.0048 21.5653C31.6479 19.8319 32 17.9571 32 16Z"
        fill="white"
      />
      <path d="M15.9999 32C22.8794 32 28.7441 27.658 31.0047 21.5652H0.995117C3.2558 27.658 9.12049 32 15.9999 32Z" fill="#0052B4" />
      <path d="M0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 15.9999 0C9.12049 0 3.2558 4.342 0.995117 10.4348Z" fill="#D80027" />
      <path d="M20.1737 11.1305H17.3911L17.8549 7.65218L19.7099 6.26086L21.565 7.65218V10.4348L20.1737 11.1305Z" fill="#338AF3" />
      <path d="M11.8258 11.1305H14.6084L14.1446 7.65218L12.2896 6.26086L10.4346 7.65218V10.4348L11.8258 11.1305Z" fill="#338AF3" />
      <path d="M17.8553 11.1305H14.145V7.65218L16.0001 6.26086L17.8553 7.65218V11.1305Z" fill="#0052B4" />
      <path
        d="M10.4346 10.4348V18.0869C10.4346 19.909 11.3147 21.5294 12.6722 22.5452L13.6461 22.3015L14.8751 23.5379C15.2386 23.6128 15.6146 23.6522 15.9998 23.6522C16.3829 23.6522 16.7571 23.6133 17.1186 23.5391L18.5216 22.371L19.3273 22.5429C20.6843 21.5272 21.565 19.9085 21.565 18.0869V10.4348H10.4346Z"
        fill="white"
      />
      <path d="M10.4346 10.4348H12.6606V12.6609H10.4346V10.4348Z" fill="#D80027" />
      <path d="M14.8867 10.4348H17.1128V12.6609H14.8867V10.4348Z" fill="#D80027" />
      <path d="M19.3389 10.4348H21.5649V12.6609H19.3389V10.4348Z" fill="#D80027" />
      <path d="M12.6606 12.6609H14.8867V14.887H12.6606V12.6609Z" fill="#D80027" />
      <path d="M17.1128 12.6609H19.3389V14.887H17.1128V12.6609Z" fill="#D80027" />
      <path d="M10.4346 14.8862H12.6606V17.1123H10.4346V14.8862Z" fill="#D80027" />
      <path d="M12.6606 17.1124H14.8867V19.3385H12.6606V17.1124Z" fill="#D80027" />
      <path d="M14.8867 14.8862H17.1128V17.1123H14.8867V14.8862Z" fill="#D80027" />
      <path d="M19.3389 14.8862H21.5649V17.1123H19.3389V14.8862Z" fill="#D80027" />
      <path d="M17.1128 17.1124H19.3389V19.3385H17.1128V17.1124Z" fill="#D80027" />
      <path d="M14.8867 19.3384H17.1128V21.5644H14.8867V19.3384Z" fill="#D80027" />
      <path d="M12.6606 19.3386H10.5781C10.7691 20.1661 11.1446 20.9233 11.6595 21.5647H12.6606V19.3386Z" fill="#D80027" />
      <path d="M19.3389 21.5648H20.3399C20.8549 20.9234 21.2302 20.1662 21.4212 19.3387H19.3389V21.5648Z" fill="#D80027" />
      <path d="M12.6606 21.5647V22.536C13.3081 23.0232 14.0647 23.3725 14.8867 23.5401V21.5647H12.6606Z" fill="#D80027" />
      <path d="M17.1128 21.5647V23.5401C17.9349 23.3726 18.6914 23.0232 19.3389 22.536V21.5647H17.1128Z" fill="#D80027" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164486">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const hungarian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164487)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M0.995188 10.4348C0.352063 12.1681 0 14.0428 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5651L16 22.9565L31.0048 21.5651C31.6479 19.8319 32 17.9571 32 16C32 14.0428 31.6479 12.1681 31.0048 10.4348L16 9.04346L0.995188 10.4348Z"
        fill="white"
      />
      <path d="M15.9999 0C9.12049 0 3.25574 4.342 0.995117 10.4348H31.0048C28.744 4.342 22.8794 0 15.9999 0Z" fill="#D80027" />
      <path d="M15.9999 32C22.8794 32 28.744 27.658 31.0047 21.5652H0.995117C3.25574 27.658 9.12049 32 15.9999 32Z" fill="#6DA544" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164487">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const indonesian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164488)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16" fill="#A2001D" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164488">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const japanese = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164490)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M16 22.9565C19.8419 22.9565 22.9565 19.8419 22.9565 16C22.9565 12.158 19.8419 9.04346 16 9.04346C12.158 9.04346 9.04346 12.158 9.04346 16C9.04346 19.8419 12.158 22.9565 16 22.9565Z"
        fill="#D80027"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164490">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const korean = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164491)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M21.5649 16C21.5649 17.3913 19.0733 20.8696 15.9998 20.8696C12.9262 20.8696 10.4346 17.3913 10.4346 16C10.4346 12.9264 12.9262 10.4348 15.9998 10.4348C19.0733 10.4348 21.5649 12.9264 21.5649 16Z"
        fill="#D80027"
      />
      <path
        d="M21.5649 16C21.5649 19.0736 19.0733 21.5652 15.9998 21.5652C12.9262 21.5652 10.4346 19.0736 10.4346 16"
        fill="#0052B4"
      />
      <path d="M21.8984 20.9192L23.3739 19.4437L24.3576 20.4274L22.8821 21.9028L21.8984 20.9192Z" fill="black" />
      <path d="M19.4385 23.3784L20.9139 21.903L21.8976 22.8866L20.4221 24.3621L19.4385 23.3784Z" fill="black" />
      <path d="M24.8496 23.87L26.3251 22.3945L27.3087 23.3782L25.8333 24.8537L24.8496 23.87Z" fill="black" />
      <path d="M22.3896 26.3296L23.8651 24.8541L24.8488 25.8378L23.3733 27.3132L22.3896 26.3296Z" fill="black" />
      <path d="M23.374 22.3948L24.8495 20.9193L25.8331 21.903L24.3577 23.3784L23.374 22.3948Z" fill="black" />
      <path d="M20.9146 24.8539L22.39 23.3784L23.3737 24.3621L21.8982 25.8375L20.9146 24.8539Z" fill="black" />
      <path d="M24.856 11.0835L20.9214 7.14891L21.905 6.16525L25.8396 10.0998L24.856 11.0835Z" fill="black" />
      <path d="M20.9209 10.1002L19.4454 8.62476L20.429 7.64114L21.9045 9.11661L20.9209 10.1002Z" fill="black" />
      <path d="M23.3799 12.5599L21.9044 11.0845L22.888 10.1009L24.3635 11.5763L23.3799 12.5599Z" fill="black" />
      <path d="M23.8716 7.14868L22.3961 5.67322L23.3798 4.68956L24.8552 6.16502L23.8716 7.14868Z" fill="black" />
      <path d="M26.332 9.60876L24.8566 8.1333L25.8402 7.14964L27.3157 8.62511L26.332 9.60876Z" fill="black" />
      <path d="M5.67236 22.392L9.60695 26.3266L8.62329 27.3102L4.6887 23.3756L5.67236 22.392Z" fill="black" />
      <path d="M9.60645 23.3749L11.0819 24.8503L10.0983 25.834L8.62283 24.3585L9.60645 23.3749Z" fill="black" />
      <path d="M7.14697 20.9163L8.62244 22.3917L7.63878 23.3754L6.16332 21.8999L7.14697 20.9163Z" fill="black" />
      <path d="M8.62305 19.4403L12.5576 23.3749L11.574 24.3586L7.63939 20.424L8.62305 19.4403Z" fill="black" />
      <path d="M9.60645 5.67017L5.67186 9.60475L4.6882 8.6211L8.62279 4.68651L9.60645 5.67017Z" fill="black" />
      <path d="M11.082 7.14551L7.14744 11.0801L6.16379 10.0964L10.0984 6.16185L11.082 7.14551Z" fill="black" />
      <path d="M12.5586 8.62195L8.62401 12.5565L7.64039 11.5729L11.575 7.63833L12.5586 8.62195Z" fill="black" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164491">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const norwegian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164492)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path d="M0.55127 20.174C1.47702 23.6089 3.51733 26.586 6.26096 28.6941V20.174H0.55127Z" fill="#D80027" />
      <path
        d="M14.6089 31.9391C15.0675 31.9786 15.5313 32 16.0002 32C23.3926 32 29.613 26.9862 31.449 20.174H14.6089V31.9391Z"
        fill="#D80027"
      />
      <path
        d="M31.449 11.8261C29.613 5.01381 23.3926 0 16.0002 0C15.5313 0 15.0675 0.021375 14.6089 0.060875V11.8261H31.449Z"
        fill="#D80027"
      />
      <path d="M6.26096 3.30591C3.51733 5.41403 1.47702 8.3911 0.55127 11.826H6.26096V3.30591Z" fill="#D80027" />
      <path
        d="M31.8646 13.9131H12.5218H12.5218V0.380371C11.0431 0.708246 9.64131 1.23968 8.34781 1.9455V13.913V13.9131H0.135438C0.046375 14.5962 0 15.2927 0 16.0001C0 16.7074 0.046375 17.4039 0.135438 18.087H8.34775H8.34781V30.0546C9.64131 30.7603 11.0431 31.2919 12.5218 31.6197V18.0872V18.0871H31.8646C31.9535 17.4039 32 16.7074 32 16.0001C32 15.2927 31.9535 14.5962 31.8646 13.9131Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164492">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const polish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164493)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16" fill="#D80027" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164493">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const portugese_br = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164494)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#6DA544"
      />
      <path d="M15.9996 6.26086L29.217 16L15.9996 25.7391L2.78223 16L15.9996 6.26086Z" fill="#FFDA44" />
      <path
        d="M15.9998 21.5652C19.0733 21.5652 21.5649 19.0736 21.5649 16C21.5649 12.9264 19.0733 10.4348 15.9998 10.4348C12.9262 10.4348 10.4346 12.9264 10.4346 16C10.4346 19.0736 12.9262 21.5652 15.9998 21.5652Z"
        fill="white"
      />
      <path
        d="M13.2173 15.6522C12.2496 15.6522 11.3156 15.7994 10.4365 16.0725C10.4755 19.1125 12.9507 21.5653 16 21.5653C17.8855 21.5653 19.5507 20.6267 20.5574 19.1923C18.8351 17.0362 16.185 15.6522 13.2173 15.6522Z"
        fill="#0052B4"
      />
      <path
        d="M21.4619 17.0663C21.5289 16.721 21.5651 16.3648 21.5651 16C21.5651 12.9264 19.0734 10.4348 15.9999 10.4348C13.7065 10.4348 11.7377 11.8224 10.8857 13.8035C11.6389 13.6474 12.4186 13.5653 13.2173 13.5653C16.4496 13.5652 19.3737 14.9088 21.4619 17.0663Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164494">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const portugese_pt = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164495)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M0 16.0001C0 22.8794 4.342 28.7441 10.4347 31.0048L11.8261 16L10.4347 0.995239C4.342 3.25599 0 9.12061 0 16.0001Z"
        fill="#6DA544"
      />
      <path
        d="M31.9999 16C31.9999 7.1635 24.8364 0 15.9999 0C14.0428 0 12.1679 0.352063 10.4346 0.995188V31.0048C12.1679 31.648 14.0428 32 15.9999 32C24.8364 32 31.9999 24.8365 31.9999 16Z"
        fill="#D80027"
      />
      <path
        d="M10.4343 21.5652C13.5079 21.5652 15.9995 19.0736 15.9995 16C15.9995 12.9264 13.5079 10.4348 10.4343 10.4348C7.36076 10.4348 4.86914 12.9264 4.86914 16C4.86914 19.0736 7.36076 21.5652 10.4343 21.5652Z"
        fill="#FFDA44"
      />
      <path
        d="M7.30469 13.2174V16.6957C7.30469 18.4245 8.70619 19.8261 10.4351 19.8261C12.1641 19.8261 13.5656 18.4246 13.5656 16.6957V13.2174H7.30469Z"
        fill="#D80027"
      />
      <path
        d="M10.4351 17.7391C9.85973 17.7391 9.3916 17.2709 9.3916 16.6956V15.3043H11.4785V16.6956C11.4785 17.2709 11.0104 17.7391 10.4351 17.7391Z"
        fill="white"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164495">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const romanian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164496)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M21.5656 0.995125C19.8323 0.352063 17.9576 8.31859e-09 16.0004 8.31859e-09C14.0433 -6.24917e-05 12.1686 0.352063 10.4353 0.995125L9.04395 15.9999L10.4353 31.0047C12.1685 31.648 14.0433 32 16.0004 32C17.9575 32 19.8323 31.648 21.5656 31.0047L22.9569 16L21.5656 0.995125Z"
        fill="#FFDA44"
      />
      <path
        d="M32.0002 16.0001C32.0002 9.12068 27.6582 3.25586 21.5654 0.995239V31.005C27.6582 28.7441 32.0002 22.8796 32.0002 16.0001Z"
        fill="#D80027"
      />
      <path
        d="M0 15.9999C0 22.8795 4.342 28.7441 10.4347 31.0049L10.4347 0.995239C4.342 3.25586 0 9.12049 0 15.9999H0Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164496">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const russian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164497)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M31.0048 21.5652C31.648 19.8319 32 17.9571 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348H0.995188C0.352063 12.1681 0 14.0429 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.9565L31.0048 21.5652Z"
        fill="#0052B4"
      />
      <path d="M15.9999 32C22.8794 32 28.7441 27.658 31.0047 21.5652H0.995117C3.2558 27.658 9.12049 32 15.9999 32Z" fill="#D80027" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164497">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const slovak = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164498)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M16 32C24.8365 32 32 24.8365 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348H0.995188C0.352063 12.1681 0 14.0429 0 16C0 24.8365 7.1635 32 16 32Z"
        fill="#0052B4"
      />
      <path d="M15.9999 32C22.8794 32 28.7441 27.658 31.0047 21.5652H0.995117C3.2558 27.658 9.12049 32 15.9999 32Z" fill="#D80027" />
      <path
        d="M4.1377 9.04346V17.0251C4.1377 21.5653 10.069 22.9565 10.069 22.9565C10.069 22.9565 16.0003 21.5653 16.0003 17.0251V9.04346H4.1377Z"
        fill="white"
      />
      <path
        d="M5.52832 9.04346V17.0251C5.52832 17.5581 5.6467 18.0615 5.8812 18.5334H14.2554C14.4899 18.0615 14.6083 17.5581 14.6083 17.0251V9.04346H5.52832Z"
        fill="#D80027"
      />
      <path
        d="M12.8513 14.6087H10.7644V13.2174H12.1558V11.8261H10.7644V10.4348H9.37313V11.8261H7.98188V13.2174H9.37313V14.6087H7.28613V16H9.37313V17.3913H10.7644V16H12.8513V14.6087Z"
        fill="white"
      />
      <path
        d="M7.77952 20.4756C8.67609 21.0391 9.59721 21.3662 10.0688 21.5117C10.5403 21.3662 11.4615 21.0391 12.358 20.4756C13.2621 19.9074 13.896 19.2575 14.2558 18.5334C13.8589 18.2526 13.3746 18.087 12.8514 18.087C12.6609 18.087 12.4758 18.1096 12.2979 18.151C11.9208 17.2942 11.0649 16.6957 10.0688 16.6957C9.07277 16.6957 8.21677 17.2942 7.83977 18.151C7.66184 18.1096 7.47671 18.087 7.28627 18.087C6.76309 18.087 6.27877 18.2526 5.88184 18.5334C6.24152 19.2574 6.87534 19.9073 7.77952 20.4756Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164498">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const slovenian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164499)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M31.0048 10.4348H13.9131V6.26086H5.56519V10.4348H0.995188C0.352063 12.1681 0 14.0429 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.9565L31.0048 21.5652C31.6479 19.8319 32 17.9571 32 16C32 14.0429 31.6479 12.1681 31.0048 10.4348Z"
        fill="#0052B4"
      />
      <path d="M15.9999 32C22.8794 32 28.7441 27.658 31.0047 21.5652H0.995117C3.2558 27.658 9.12049 32 15.9999 32Z" fill="#D80027" />
      <path
        d="M5.56543 10.4348V11.826C5.56543 15.0211 9.73937 16 9.73937 16C9.73937 16 13.9133 15.0211 13.9133 11.826V10.4348L12.522 11.8261L9.73937 9.73914L6.95674 11.8261L5.56543 10.4348Z"
        fill="white"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164499">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const swedish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164501)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#FFDA44"
      />
      <path
        d="M12.5225 13.9131H31.8653C30.8426 6.06262 24.1299 0 16.0007 0C14.8061 0 13.6424 0.132063 12.5225 0.380313V13.9131H12.5225Z"
        fill="#0052B4"
      />
      <path d="M8.34812 13.913V1.94543C3.95474 4.34256 0.80968 8.7395 0.135742 13.9131H8.34812V13.913Z" fill="#0052B4" />
      <path d="M8.34805 18.0869H0.135742C0.80968 23.2605 3.95474 27.6574 8.34812 30.0545L8.34805 18.0869Z" fill="#0052B4" />
      <path
        d="M12.5225 18.087V31.6197C13.6424 31.8679 14.8061 32 16.0007 32C24.1299 32 30.8426 25.9374 31.8653 18.0869H12.5225V18.087Z"
        fill="#0052B4"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164501">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const thai = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164502)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M31.0048 10.4348H0.995188C0.352 12.1681 0 14.0429 0 16C0 17.9571 0.352 19.8319 0.995188 21.5652H31.0049C31.648 19.8319 32 17.9571 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348Z"
        fill="#0052B4"
      />
      <path d="M15.9999 0C11.1505 0 6.80528 2.15775 3.87109 5.56519H28.1287C25.1945 2.15775 20.8493 0 15.9999 0Z" fill="#D80027" />
      <path
        d="M28.1287 26.4348H3.87109C6.80528 29.8423 11.1505 32 15.9999 32C20.8493 32 25.1945 29.8423 28.1287 26.4348Z"
        fill="#D80027"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164502">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const turkish = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164503)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#D80027"
      />
      <path
        d="M15.3453 13.0741L16.6581 14.8832L18.7841 14.1938L17.4693 16.0013L18.7819 17.8103L16.6566 17.1183L15.3418 18.9258L15.3431 16.6907L13.2178 15.9987L15.3439 15.3093L15.3453 13.0741Z"
        fill="white"
      />
      <path
        d="M11.7623 20.5217C9.26507 20.5217 7.24057 18.4972 7.24057 15.9999C7.24057 13.5027 9.26507 11.4782 11.7623 11.4782C12.5409 11.4782 13.2736 11.6751 13.9132 12.0217C12.9098 11.0403 11.5374 10.4347 10.0232 10.4347C6.94957 10.4347 4.45801 12.9263 4.45801 15.9999C4.45801 19.0734 6.94963 21.5651 10.0232 21.5651C11.5376 21.5651 12.9098 20.9594 13.9132 19.9781C13.2736 20.3248 12.5409 20.5217 11.7623 20.5217Z"
        fill="white"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164503">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ukrainian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164504)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#FFDA44"
      />
      <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16" fill="#338AF3" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164504">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const vietnamese = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164505)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#D80027"
      />
      <path
        d="M16 8.34778L17.7268 13.6621H23.3146L18.7939 16.9465L20.5207 22.2608L16 18.9764L11.4794 22.2608L13.2062 16.9465L8.68555 13.6621H14.2733L16 8.34778Z"
        fill="#FFDA44"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164505">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const chinese_ch = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164506)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#D80027"
      />
      <path
        d="M8.75625 9.73755L10.1375 13.9875H14.6062L10.9937 16.6188L12.375 20.8688L8.75625 18.2438L5.1375 20.8688L6.525 16.6188L2.90625 13.9875H7.375L8.75625 9.73755Z"
        fill="#FFDA44"
      />
      <path
        d="M18.9689 24.7813L17.9127 23.4813L16.3502 24.0875L17.2564 22.6813L16.2002 21.375L17.8189 21.8063L18.7314 20.4L18.8189 22.075L20.4439 22.5063L18.8752 23.1063L18.9689 24.7813Z"
        fill="#FFDA44"
      />
      <path
        d="M21.0689 20.9688L21.5689 19.3688L20.2002 18.4L21.8752 18.375L22.3689 16.775L22.9127 18.3625L24.5877 18.3438L23.2439 19.3438L23.7814 20.9313L22.4127 19.9625L21.0689 20.9688Z"
        fill="#FFDA44"
      />
      <path
        d="M23.8998 11.7438L23.1623 13.2501L24.3623 14.4188L22.7061 14.1813L21.9686 15.6813L21.6811 14.0313L20.0186 13.7938L21.5061 13.0126L21.2186 11.3563L22.4186 12.5251L23.8998 11.7438Z"
        fill="#FFDA44"
      />
      <path
        d="M19.0129 7.18127L18.8879 8.85003L20.4441 9.48128L18.8129 9.88128L18.6941 11.5563L17.8129 10.1313L16.1816 10.5313L17.2629 9.25002L16.3754 7.83127L17.9316 8.46252L19.0129 7.18127Z"
        fill="#FFDA44"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164506">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const chinese_hong = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164507)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#D80027"
      />
      <path
        d="M17.652 12.1043C17.2883 13.6167 16.6423 13.3283 16.3252 14.6473C14.4575 14.1982 13.3073 12.3201 13.7563 10.4523C14.2052 8.5846 16.0835 7.43435 17.9513 7.88342C17.3171 10.5214 17.9773 10.7516 17.652 12.1043Z"
        fill="white"
      />
      <path
        d="M12.8056 13.225C14.1317 14.0381 13.6577 14.5635 14.814 15.2727C13.8098 16.9103 11.6682 17.4237 10.0306 16.4195C8.39304 15.4154 7.87947 13.2737 8.88372 11.6361C11.1966 13.0544 11.6194 12.4977 12.8056 13.225Z"
        fill="white"
      />
      <path
        d="M12.3742 18.1808C13.5574 17.1709 13.9105 17.7841 14.9423 16.9034C16.1895 18.3645 16.016 20.56 14.555 21.8072C13.0939 23.0544 10.8984 22.8807 9.65137 21.4198C11.7147 19.6583 11.3159 19.084 12.3742 18.1808Z"
        fill="white"
      />
      <path
        d="M16.9537 20.1229C16.3587 18.6856 17.0509 18.5391 16.5322 17.2858C18.3072 16.5512 20.3417 17.3946 21.0763 19.1695C21.8109 20.9445 20.9674 22.9789 19.1924 23.7135C18.1551 21.2067 17.4858 21.4085 16.9537 20.1229Z"
        fill="white"
      />
      <path
        d="M20.2154 16.3673C18.6645 16.489 18.739 15.7852 17.3868 15.8913C17.2366 13.9764 18.6675 12.302 20.5825 12.1517C22.4975 12.0017 24.1719 13.4325 24.322 15.3476C21.6172 15.5597 21.6023 16.2586 20.2154 16.3673Z"
        fill="white"
      />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164507">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const italian = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7051_164489)">
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="white"
      />
      <path
        d="M32.0002 16.0001C32.0002 9.12061 27.6582 3.25593 21.5654 0.995239V31.0049C27.6582 28.7442 32.0002 22.8795 32.0002 16.0001Z"
        fill="#D80027"
      />
      <path d="M0 16.0001C0 22.8795 4.342 28.7442 10.4348 31.0049V0.995239C4.342 3.25593 0 9.12061 0 16.0001Z" fill="#6DA544" />
    </g>
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EEEEEE" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_7051_164489">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
